import { render, staticRenderFns } from "./I8nTextareaMention.vue?vue&type=template&id=edcf89da&"
import script from "./I8nTextareaMention.vue?vue&type=script&lang=js&"
export * from "./I8nTextareaMention.vue?vue&type=script&lang=js&"
import style0 from "./I8nTextareaMention.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports